<template>
  <div class="cover">
    <Header @search="onSearch" />
    <Tab />
    <div class="cover_home">
      <div class="cover_header">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">{{
            $t('首页')
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/home' }">{{
            $t('新闻中心')
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('最新通知') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="cover_title">{{ $t('最新通知') }}</div>
      <div class="cover_content">
        <ul class="cover_tab" v-if="coverData.length != 0">
          <li
            v-for="(item, index) in coverData"
            :key="index"
            @click="changeTabInd(index, item)"
            :class="{ cover_active: coverInd == index }"
            :clstag="`newscenter|keycount|cover-pc|click-${item.name}`"
          >
            {{ item.value }}
          </li>
        </ul>
        <ul class="item_box" v-if="itemList.length.length != 0">
          <li
            v-for="(item, index) in itemList"
            :key="index"
            @click="coverDetailBtn(item.contentId)"
            :clstag="`newscenter|keycount|cover-pc|link-${item.title}`"
          >
            <span>{{ index + 1 }}</span>
            <span :class="{ title_active: item.isMark == 1 }">
              <p class="text-oneline width900" style="display: inline">
                {{ item.title }}
              </p>
              <i v-if="item.pubTime >= todyTimer">
                <img src="@/assets/img/new.png" alt="" />
              </i>
              <!-- <i v-if="item.top == 1">
                <img src="@/assets/img/stick.png" alt="" />
              </i> -->
            </span>
            <span>{{
              item.pubTime || item.createTime | dataFilter(true)
            }}</span>
          </li>
        </ul>
        <ul class="no" v-if="itemList.length == 0">
          <img src="@/assets/img/no.png" alt="" />
          {{
            $t('暂无数据')
          }}
        </ul>
        <div class="c_page">
          <p @click="subCurrent">&lt;&lt;</p>
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :clstag="`newscenter|keycount|cover-PC|click-handleCurrentChange`"
          >
          </el-pagination>
          <p @click="addCurrent">&gt;&gt;</p>
          <span
            >{{ $t('共') }}{{ total }}{{ $t('条结果') }} /{{ pageNum
            }}{{ $t('页') }}</span
          >
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import '@/assets/css/cover.css'
import { getNoticeList, getNoticeClassify } from '@/api/news'
import { formatDate } from '@/utils/formatDate'
import Header from './components/headerBanner'
import Tab from './components/headerTab'
import Footer from './components/footer'
export default {
  components: {
    Header,
    Tab,
    Footer
  },
  data() {
    return {
      coverData: [],
      coverInd: 0,
      codes: '',
      pageSize: 10,
      pageNum: 1,
      itemList: [],
      itemCode: '',
      total: 0,
      todyTimer: ''
    }
  },
  computed: {},
  watch: {},
  created() {
    this.codes = this.$route.query.code
    this.allData()
    window.scroll(0, 0)
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    all() {
      this.allActive = true
      this.coverInd = -1
    },
    changeTabInd(i, it) {
      this.coverInd = i
      this.itemCode = it.code
      if (it.code == 'all') {
        this.allData()
      } else {
        getNoticeList({
          cls: this.itemCode,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        }).then(res => {
          this.itemList = res.result && res.result.infos
          this.total = res.result.total
        })
      }
    },
    handleCurrentChange(num) {
      this.pageNum = num
      this.allData()
    },
    allData() {
      getNoticeList({
        cls: this.codes,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then(res => {
        this.itemList = res.result && res.result.infos
        this.total = res.result.total
      })
    },
    coverDetailBtn(id) {
      this.$router.push({
        path: '/consult',
        query: {
          id: id,
          type: 2
        }
      })
    },
    subCurrent() {
      this.pageNum = 1
      this.allData()
    },
    addCurrent() {
      this.pageNum = Math.ceil(this.total / this.pageSize)
      this.allData()
    }
  },

  async mounted() {
    const res = await getNoticeClassify()
    this.coverData = res.result.data
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd    hh:ss')
    }
  },
  beforeCreate() {},
  beforeMount() {
    this.todyTimer = new Date().setHours(0, 0, 0, 0)
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style scoped></style>
